import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "var(--laka-ivory)" }}>
        <div className="font-display text-2xl" style={{ color: "#D6B36A" }}>LAKA</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/catalogo" replace />;
  return children;
}
